import { h, render, Component } from 'preact';
import TxrNavbar from './txr-navbar';
import { appConfig } from '../app.config';
import { classNames } from '../utils/utils';

class TxrHeader extends Component {
    state = {
        isMobileMenuOpened: false,
        isScrolled: false,
        isWhiteHeader: false
    }
    componentDidMount() {
        const el = document.querySelector('.txr-white-header-required');
        if (!!el) {
            this.setState({ isWhiteHeader: true });
        }

        window.onscroll = () => {

            if (window.pageYOffset >= 3) {
                if (!this.state.isScrolled) {
                    this.setState({ isScrolled: true });
                }

                // body.classList.add('txr-www-app__sticky-header')
            }
            if (window.pageYOffset < 3) {
                if (this.state.isScrolled) {
                    this.setState({ isScrolled: false });
                }
                //body.classList.remove('txr-www-app__sticky-header')
            }
        };
    }

    toggle = (value) => {
        this.setState({ isMobileMenuOpened: value });
        // trigger a component update

        if (value) {
            document.body.classList.add('txr-mobile-menu__opened');
        } else {
            document.body.classList.remove('txr-mobile-menu__opened');
        }
    }

    render() {
        return (
            <header class={'txr-header' + (this.state.isMobileMenuOpened ? ' txr-mobile-menu__opened' : '') + (this.state.isScrolled ? ' txr-mobile-menu__scrolled' : '') + (this.state.isWhiteHeader ? ' txr-white-header' : '')}>
                <div class="txr-header__content">
                    <a class="txr-header__logo" href="/">
                        <img class="logo" alt="logo" src={this.state.isWhiteHeader ? '/images/logo-bluegreen-esendex.svg' : '/images/logo-whitegreen-esendex.svg'} />
                        <img class="hover-logo" alt="logo" src={this.state.isWhiteHeader ? '/images/logo-blueteal-esendex.svg' : '/images/logo-whiteteal-esendex.svg'} />
                        
                    </a>
                    <TxrNavbar isMobileMenuOpened={this.state.isMobileMenuOpened} isWhiteHeader={this.state.isWhiteHeader} onClose={() => this.toggle(false)} />
                    <div class="txr-header__buttons-container">
                        <div class="txr-header__buttons">
                            <a class="txr-button-link" href={appConfig.appUrl + '/app/login'}>
                                <button class={'txr-button txr-action-button txr-small-button' + (this.state.isWhiteHeader ? ' txr-black-text': '')} type="button">LOGIN</button>
                            </a>
                            {/*<a class="txr-button-link sign-up" href="/pricing">
                                <button class={'txr-button txr-action-button txr-small-button' + (this.state.isWhiteHeader ? ' txr-black-text': '')} type="button">SIGN UP</button>
                            </a>*/}
                            {<a class="txr-button-link" href="/trial">
                                <button class={'txr-button txr-primary-button txr-small-button' + (this.state.isWhiteHeader ? ' txr-black-text' : '')} type="button">TRY IT FREE</button>
                            </a>}
                            <a class="txr-button-link" href="/demo">
                                <button class={'txr-button txr-primary-button txr-small-button' + (this.state.isWhiteHeader ? ' txr-black-text': '')} type="button">DEMO</button>
                            </a>

                        </div>
                        <div class="txr-header__mobile-button" onClick={(e) => this.toggle(true)} >
                            <i class="fal fa-bars" />
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default TxrHeader;
